import type { DayHours } from '@/types'

export const business = {
    tagline: "Hand car wash and valeting centre",
    phone: {
        display: '01632 960 418',
        href: 'tel:+441632960418'
    },
    address: ["Unit 4, Riverside Retail Park", "Station Road"],
    directionsUrl: 'https://www.google.com/maps/search/?api=1&query=Unit%204%20Riverside%20Retail%20Park%20Station%20Road'
}

export const OPENING_HOURS: Array<DayHours> = [
    { day: 1, name: 'Monday', short: 'Mon', open: '08:00', close: '18:00' },
    { day: 2, name: 'Tuesday', short: 'Tue', open: '08:00', close: '18:00' },
    { day: 3, name: 'Wednesday', short: 'Wed', open: '08:00', close: '18:00' },
    { day: 4, name: 'Thursday', short: 'Thu', open: '08:00', close: '18:00' },
    { day: 5, name: 'Friday', short: 'Fri', open: '08:00', close: '18:00' },
    { day: 6, name: 'Saturday', short: 'Sat', open: '08:00', close: '18:00' },
    { day: 0, name: 'Sunday', short: 'Sun', open: '09:00', close: '16:00' }
]

export const SLOT_INTERVAL_MINUTES = 30

export const LAST_SLOT_BEFORE_CLOSE_MINUTES = 60

export const SAME_DAY_NOTICE_MINUTES = 30

export const BOOKING_DAYS_AHEAD = 14

export const VEHICLE_TYPES = [
    "Small or medium car",
    "Large car or estate",
    "SUV or 4x4",
    "Van or 7-seater"
]

export const NAV_LINKS = [
    { label: 'Prices', href: '/#packages' },
    { label: 'Add-ons', href: '/#add-ons' },
    { label: 'How it works', href: '/#how-it-works' },
    { label: 'Reviews', href: '/#reviews' },
    { label: 'Visit us', href: '/#visit' }
]
